import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { formatDate } from '@helpers/helper.novelty'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Novelty, RealEstateDataPageComponentData } from 'types'

const SummaryNovelties_8 = (props: RealEstateDataPageComponentData) => {
  const { global_data } = props
  const { id: siteId, divisionPath } = global_data
  const { title, button, backgroundColor, titleElement, titleColor } = props

  const { data: allBlogData, isLoading, isError } = useGetBlogsQuery({ site: siteId })

  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const getFeaturedAndRefillByDate = () => {
    if (allBlogData) {
      const featured = allBlogData.news.filter((novelty) => novelty.featured)
      const notfeatured = allBlogData.news.filter((novelty) => !novelty.featured)
      const total = [...featured, ...notfeatured]
      return total.slice(0, 4)
    }
    return []
  }

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const noveltyPath = (novelty?: Novelty) =>
    novelty?.id ? `${divisionPath ?? ''}/novedad/${novelty.id}/${novelty.slug}` : '/'

  const noveltyCard = (novelty?: Novelty) => (
    <Link
      to={noveltyPath(novelty)}
      className="cursor-pointer"
    >
      <Row className="align-items-center">
        <Col
          xs={12}
          lg={4}
          className="d-flex justify-content-center"
        >
          <div className="image-zoom-container">
            <img
              src={novelty?.image}
              alt="portada"
              className="image-zoom"
              style={{
                height: '190px',
                width: '100%',
                objectFit: 'cover',
              }}
            />
          </div>
        </Col>
        <Col
          xs={12}
          lg={8}
          className="text-start"
        >
          <ElementHTML
            children={formatDate(novelty?.date_published, 'long')}
            elementType={'p'}
            className="text-dark-gray mb-4 mt-3 mt-lg-0"
          />
          <ElementHTML
            children={novelty?.title}
            elementType={'h4'}
            className="text-black mb-3 col-6"
          />
          <ElementHTML
            children={novelty?.headline}
            elementType={'p'}
            className="text-dark-gray"
          />
        </Col>
      </Row>
    </Link>
  )

  return (
    isMounted &&
    !isLoading &&
    !isError &&
    getFeaturedAndRefillByDate()?.length > 0 && (
      <section
        id="summary-novelties"
        className="p-y-config summary-novelties-8"
        style={backgroundColor ? { backgroundColor: backgroundColor } : {}}
      >
        <Container fluid>
          <Row>
            {' '}
            <ElementHTML
              children={title ?? 'Novedades'}
              elementType={titleElement ?? 'h2'}
              style={titleColor ? { color: titleColor } : {}}
              className="mb-4"
            />
          </Row>
          <Row>
            <Col
              xs={12}
              lg={7}
            >
              <div className="img-container">
                <img
                  src={getFeaturedAndRefillByDate()?.[0]?.image ?? ''}
                  alt="portada"
                />
                <div className="img-overlay"></div>
                <Row>
                  <Col
                    xs={12}
                    lg={6}
                    className="section-name"
                  >
                    <ElementHTML
                      children={formatDate(
                        getFeaturedAndRefillByDate()?.[0]?.date_published,
                        'long',
                      )}
                      elementType={'h5'}
                      className="text-white mb-4"
                    />
                    <ElementHTML
                      children={getFeaturedAndRefillByDate()?.[0].title}
                      elementType={'h2'}
                      className="text-white mb-3"
                    />
                    <ElementHTML
                      children={getFeaturedAndRefillByDate()?.[0].headline}
                      elementType={'p'}
                      className="text-white mb-5"
                    />
                    <Link
                      className={'btn btn-white border w-auto text-white'}
                      to={noveltyPath(getFeaturedAndRefillByDate()?.[0])}
                    >
                      {button?.value ?? 'VER NOTA COMPLETA'}
                      <i className={`icon-arrow-stick ms-4 ${iconsStyle}`}></i>
                    </Link>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col
              xs={12}
              lg={5}
              className="text-center mt-5 mt-lg-0"
            >
              {getFeaturedAndRefillByDate()
                ?.slice(1, 4)
                .map((novelty, index) => (
                  <div
                    key={index}
                    className="mb-4"
                  >
                    {noveltyCard(novelty)}
                  </div>
                ))}
              <Link
                className={'btn btn-primary border w-auto '}
                to={button?.link ?? '/'}
              >
                {button?.value ?? 'VER TODAS LAS NOVEDADES'}
                {button?.image && (
                  <img
                    src={button?.image}
                    alt=""
                  />
                )}
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    )
  )
}

export default SummaryNovelties_8
